import clsx from "clsx"

const ActionComponent = ({ value }) => {

    return <div className={clsx(["btn btn-xs"], {
        'btn-success': value?.action === 'creación',
        'btn-primary': value?.action === 'modificación',
        'btn-danger': value?.action === 'eliminación'
    })}>
        {value?.action}
    </div>
}

export default ActionComponent;